import { TrashIcon } from '@heroicons/react/24/outline'
import { ContentAction, ContentActionView, ContentView } from '../../../api/client'
import { isActionApplied } from '../../content/content-card/actions'
import ActionGenericButton from './GenericActionButton'

type Props = {
    content: ContentView
    onActionClick: (actions: ContentActionView[], queued?: boolean) => void
    actions: ContentActionView[]
    disabled?: boolean
    disabledMessage?: string
}

export default function DeleteButton(props: Props) {
    const { content, onActionClick, actions, disabled, disabledMessage } = props

    const actionAlreadyApplied = isActionApplied(actions, ContentAction.Delete)

    if (actionAlreadyApplied) {
        return (
            <>
                <div
                    data-tooltip-id="tooltip-id"
                    data-tooltip-content="This content has been deleted. This action cannot be undone."
                    className="flex h-10 w-10 items-center justify-center rounded-full bg-red-700 p-2 text-red-200"
                >
                    <TrashIcon />
                </div>
            </>
        )
    }

    return (
        <ActionGenericButton
            content={content}
            onActionClick={onActionClick}
            action={ContentAction.Delete}
            tooltip="Delete this content"
            colour="red"
            icon={<TrashIcon />}
            actions={actions}
            disabled={disabled}
            disabledMessage={disabledMessage}
        />
    )
}
